enum Paths {
    couponCreate = '/coupon/create',
    coupon = '/coupon',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/Coupon/paths.ts